import React from 'react';
import UserManagement from '../../components/admin/UserManagement';

const UserManagementPage = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">User Management</h1>
      <UserManagement />
    </div>
  );
};

export default UserManagementPage;
